import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(6),
  },
  emptyText: {
    textAlign: "center",
  },
  coinNameAndIcon: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  coinTitle: {
    color: theme.palette.secondary.tint40,
    marginLeft: theme.spacing(3),
  },
  currencyName: {
    marginLeft: theme.spacing(7),
  },
  coinLogoAndText: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(7),
  },
  deleteButton: {
    minWidth: theme.spacing(10),
  },
  wrapperLastCol: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // width: theme.spacing(40),
  },

  xBtn: {
    color: theme.palette.secondary.tint40,
    fontSize: theme.spacing(8),
    height: theme.spacing(15),
    width: theme.spacing(15),
    borderRadius: theme.spacing(4),
    marginRight: theme.spacing(4),
    backgroundColor: theme.palette.background.main,
    transition: ".1s ease-in",
    "&:hover": {
      backgroundColor: theme.palette.red2.main,
      color: theme.palette.white.main,
    },
  },
  detailBtn: {
    color: theme.palette.secondary.tint40,
    fontSize: theme.spacing(8),
    borderRadius: theme.spacing(4),
    height: theme.spacing(15),
    width: theme.spacing(15),
    backgroundColor: theme.palette.background.main,
    transition: ".1s ease-in",
    "&:hover": {
      backgroundColor: theme.palette.info.main,
      color: theme.palette.white.main,
    },
  },
  seperator: {
    margin: theme.spacing(0, 1),
  },
  orderTypeWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  orderTypeIconDown: {
    color: theme.palette.primary.main,
    fontSize: theme.fontSize["16"],
    margin: theme.spacing(0, 1),
  },
  orderTypeIconUp: {
    color: theme.palette.red.main,
    fontSize: theme.fontSize["16"],
    margin: theme.spacing(0, 1),
  },
  popOver: {
    maxWidth: theme.spacing(150),
    minHeight: theme.spacing(61),
    padding: theme.spacing(10),
    backgroundColor: theme.palette.black.main,
    color: theme.palette.secondary.tint15,
    direction: "ltr",
  },
  popOverContainer: {
    marginTop: -theme.spacing(15),
  },
  closeIcon: {
    backgroundColor: theme.palette.red.main,
    borderRadius: "50%",
  },
  popOverText: {
    color: theme.palette.secondary.tint15,
  },
  input: {
    width: theme.spacing(90),
    height: theme.spacing(15),
    padding: 0,
    backgroundColor: theme.palette.secondary.tint90,
    "& .Mui-disabled": {
      backgroundColor: "inherit !important",
      height: [theme.spacing(15), "!important"],
    },
    "& input": {
      color: theme.palette.secondary.tint15,
    },
  },
}));
